<template>
    <div>
        <ul ref="list" class="offering-listing__holder">
            <li v-for="item in items" :key="item.id">
                <EventRow :item="item" :icons="icons" />
            </li>
        </ul>

        <slot />
    </div>
</template>

<script setup>
import { ref } from 'vue'

import EventRow from './EventRow.vue'

defineProps({
    items: { type: Array, default: () => [] },
    icons: { type: Object, default: () => ({}) },
})

const list = ref(null)

const focusItemAt = (index) => {
    const link = list.value?.querySelectorAll('.offering-row')[index]

    if (link) {
        link.focus({ preventScroll: true })
    }
}

defineExpose({ focusItemAt })
</script>
